var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "all_discuss_main" }, [
    _c("div", { staticClass: "all_discuss_list" }, [
      _c("div", { staticClass: "discuss_list_wrap" }, [
        _vm.discussList && _vm.discussList.length > 0
          ? _c(
              "ul",
              _vm._l(_vm.discussList, function(item, key) {
                return _c(
                  "li",
                  {
                    key: key,
                    staticClass: "lis",
                    on: {
                      click: function($event) {
                        return _vm.jumpDetails(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "head_portrait" }, [
                      item.userType == 0
                        ? _c("img", { attrs: { src: _vm.teacherHead } })
                        : item.userType == 1
                        ? _c("img", { attrs: { src: _vm.teacherHead } })
                        : item.userType == 2
                        ? _c("img", {
                            attrs: {
                              src:
                                item.anonymous == 0
                                  ? _vm.anonymousHead
                                  : _vm.studentHead
                            }
                          })
                        : _c("img", { attrs: { src: _vm.anonymousHead } })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "list_info" }, [
                      _c("div", { staticClass: "list_info_line" }, [
                        _c("div", { staticClass: "list_info_line_box" }, [
                          _c("span", { staticClass: "user_name" }, [
                            _vm._v(
                              _vm._s(
                                item.anonymous == 0 ? "匿名用户" : item.userName
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "list_info_line_box" }, [
                          item.userType == 0 || item.userType == 1
                            ? _c("span", { staticClass: "user_type" }, [
                                _vm._v("教师")
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "list_info_line_box" }, [
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(item.createTimeStr))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "list_info_line_box" }, [
                          item.repliedOrParticipation
                            ? _c("span", { staticClass: "status" }, [
                                _vm._v(_vm._s(item.repliedOrParticipationName))
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list_info_line" }, [
                        _c("p", [_vm._v(_vm._s(item.theme))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list_info_line" }, [
                        item.catalogId != "" && item.discussionAreaId != 3
                          ? _c("div", { staticClass: "chapter" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../../../../static/images/study/icon/zhangjie.png")
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.catalogId != null
                                      ? item.catalogName
                                      : "全部教学章节"
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "operation" }, [
                          _c("ol", [
                            _c("li", [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../../../../static/images/study/icon/chakan_hv.png"),
                                  alt: ""
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.viewCount && item.viewCount != null
                                      ? item.viewCount
                                      : 0
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../../../../static/images/study/icon/dianzan_hv.png"),
                                  alt: ""
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.praiseCount && item.praiseCount != null
                                      ? item.praiseCount
                                      : 0
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../../../../static/images/study/icon/pinglun_hv.png"),
                                  alt: ""
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.replyCount && item.replyCount != null
                                      ? item.replyCount
                                      : 0
                                  )
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "respective_region" }, [
                      _c("span", [
                        _vm._v("【" + _vm._s(item.discussionAreaName) + "】")
                      ])
                    ]),
                    _vm._v(" "),
                    item.roofPlacement
                      ? _c("div", { staticClass: "is_top" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../../../../../static/images/study/icon/zhiding.png")
                            }
                          })
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "no_discuss_list" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../../../../static/images/wujieguo.png")
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("暂无相关内容")])
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "discuss_pagination" },
        [
          _vm.pageTotal.total > 10
            ? _c("pagination", {
                attrs: {
                  currentpage: _vm.pageTotal.currentPage,
                  limit: _vm.pageTotal.pageSize,
                  total: _vm.pageTotal.total,
                  layout: "sizes, prev, pager, next, jumper",
                  small: true
                },
                on: {
                  handleCurrentChange: _vm.handleCurrentChange,
                  handleSizeChange: _vm.handleSizeChange
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a809db62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a809db62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/discuss/component/discussList.vue
// module id = null
// module chunks = 